import { Outlet, Navigate, useLocation } from "react-router-dom"
import { useEffect, useRef } from 'react'
import { useRefreshMutation } from "./authApiSlice"
import { useSelector } from 'react-redux'
import { selectCurrentToken } from "./authSlice"
import SectionLoading from '../../components/SectionLoading'

const PersistLogin = () => {
    const location = useLocation()
    const token = useSelector(selectCurrentToken)
    const hasTriedRefresh = useRef(false)

    const [refresh, {
        isUninitialized,
        isLoading,
        isSuccess,
        isError,
        error
    }] = useRefreshMutation()


    useEffect(() => {
        const verifyRefreshToken = async () => {
            try {
                await refresh()
            } catch (err) {
                console.error(err)
            }
        }

        if (!token && !hasTriedRefresh.current) {
            hasTriedRefresh.current = true
            verifyRefreshToken()
        }
    }, [token, refresh])


    let content
    if (token) { // token already in state
        content = <Outlet />
    } else if (isLoading) { // restoring session token
        content = <SectionLoading label="Restoring your session…" />
    } else if (isUninitialized) {
        content = <SectionLoading label="Restoring your session…" />
    } else if (isError) {
        content = (
            <Navigate
                to="/public/login"
                state={{ from: location, reason: error?.data?.message }}
                replace
            />
        )
    } else if (isSuccess) {
        content = <Outlet />
    }

    return content
}
export default PersistLogin